/*!
 * Not used for now...
 */
import React from 'react'
// react library for routing
import { Link } from 'react-router-dom'
// reactstrap components
import {
  UncontrolledCollapse,
  NavbarBrand,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Container,
  Row,
  Col,
  UncontrolledTooltip
} from 'reactstrap'

class AdminNavbar extends React.Component {
  render() {
    return (
      <>
        <Navbar
          className="navbar-horizontal navbar-main navbar-dark bg-white"
          expand="lg"
          id="navbar-main"
        >
          <Container>
            <NavbarBrand to="/" tag={Link}>
              <img alt="..." src={require('assets/img/brand/auth_logo.png')} />
            </NavbarBrand>
            <button
              aria-controls="navbar-collapse"
              aria-expanded={false}
              aria-label="Toggle navigation"
              className="navbar-toggler"
              data-target="#navbar-collapse"
              data-toggle="collapse"
              id="navbar-collapse"
              type="button"
            >
              <span className="navbar-toggler-icon" />
            </button>
            <UncontrolledCollapse
              className="navbar-custom-collapse"
              navbar
              toggler="#navbar-collapse"
            >
              <div className="navbar-collapse-header">
                <Row>
                  <Col className="collapse-brand" xs="6">
                    <Link to="/admin/dashboard">
                      <img
                        alt="..."
                        src={require('assets/img/brand/nav_logo.png')}
                      />
                    </Link>
                  </Col>
                  <Col className="collapse-close" xs="6">
                    <button
                      aria-controls="navbar-collapse"
                      aria-expanded={false}
                      aria-label="Toggle navigation"
                      className="navbar-toggler"
                      data-target="#navbar-collapse"
                      data-toggle="collapse"
                      id="navbar-collapse"
                      type="button"
                    >
                      <span />
                      <span />
                    </button>
                  </Col>
                </Row>
              </div>
              <hr className="d-lg-none" />
              <Nav className="align-items-lg-center ml-lg-auto" navbar>
                <NavItem>
                  <NavLink
                    className="nav-link-icon"
                    href="https://www.facebook.com/getlabme/"
                    id="tooltip601201423"
                    target="_blank"
                  >
                    <i
                      className="fab fa-facebook-square"
                      style={{ color: '#12ABC6' }}
                    />
                    <span className="nav-link-inner--text d-lg-none">
                      Facebook
                    </span>
                  </NavLink>
                  <UncontrolledTooltip delay={0} target="tooltip601201423">
                    Like us on Facebook
                  </UncontrolledTooltip>
                </NavItem>
                <NavItem>
                  <NavLink
                    className="nav-link-icon"
                    href="https://www.instagram.com/labme.ai/"
                    id="tooltip871243015"
                    target="_blank"
                  >
                    <i
                      className="fab fa-instagram"
                      style={{ color: '#12ABC6' }}
                    />
                    <span className="nav-link-inner--text d-lg-none">
                      Instagram
                    </span>
                  </NavLink>
                  <UncontrolledTooltip delay={0} target="tooltip871243015">
                    Follow us on Instagram
                  </UncontrolledTooltip>
                </NavItem>
                <NavItem>
                  <NavLink
                    className="nav-link-icon"
                    href="https://twitter.com/LabMeAnalytics"
                    id="tooltip366258619"
                    target="_blank"
                  >
                    <i
                      className="fab fa-twitter-square"
                      style={{ color: '#12ABC6' }}
                    />
                    <span className="nav-link-inner--text d-lg-none">
                      Twitter
                    </span>
                  </NavLink>
                  <UncontrolledTooltip delay={0} target="tooltip366258619">
                    Follow us on Twitter
                  </UncontrolledTooltip>
                </NavItem>
                <NavItem>
                  <NavLink
                    className="nav-link-icon"
                    href="https://www.youtube.com/channel/UCzz3--aytr3vtmSLwsiEOvQ?view_as=subscriber"
                    id="tooltip931502898"
                    target="_blank"
                  >
                    <i
                      className="fab fa-youtube"
                      style={{ color: '#12ABC6' }}
                    />
                    <span className="nav-link-inner--text d-lg-none">
                      Youtube
                    </span>
                  </NavLink>
                  <UncontrolledTooltip delay={0} target="tooltip931502898">
                    Watch us on Youtube
                  </UncontrolledTooltip>
                </NavItem>
                <NavItem>
                  <NavLink
                    className="nav-link-icon"
                    href="https://www.linkedin.com/checkpoint/challengesV2/AQFmm4TmvYDgdQAAAXKhlCxL6WwSd0Fyf3quo4obfE_QCcTvNAKPn697jgpr4j6hX8FVQPaVbYoHxUQtT02uX8uCnylCveDncA"
                    id="tooltip931502898"
                    target="_blank"
                  >
                    <i
                      className="fab fa-linkedin"
                      style={{ color: '#12ABC6' }}
                    />
                    <span className="nav-link-inner--text d-lg-none">
                      LinkedIn
                    </span>
                  </NavLink>
                  <UncontrolledTooltip delay={0} target="tooltip931502898">
                    Follow us on LinkedIn
                  </UncontrolledTooltip>
                </NavItem>
              </Nav>
            </UncontrolledCollapse>
          </Container>
        </Navbar>
      </>
    )
  }
}

/**
              <Nav className="mr-auto" navbar>
                <NavItem>
                  <NavLink to="/dashboard/dashboard" tag={Link}>
                    <span style={{color: '#12ABC6'}} className="nav-link-inner--text">Dashboard</span>
                  </NavLink>
                </NavItem>
              </Nav>
 */

export default AdminNavbar
